import {
  DigitalMarketingAgencyNearDifcPage,
  TopDigitalMarketingAgencyAlBarshaPage,
} from "../helmets/DigitalMarketing";
import { BestSEOCompanyInAlBarshaSEO } from "../helmets/SEO/al_barsha";
import {
  BestDigitalMarketingAndSEOInBurDubaiSEO,
  BestSEOCompanyInBurDubaiSEO,
} from "../helmets/SEO/bur_dubai";
import { BestSEOCompanyInDIFCSEO } from "../helmets/SEO/Difc";
import { BestDigitalMarketingAndSEOInDubaiSEO } from "../helmets/SEO/dubai";
import { CreativeWebsiteDesignCompanyInAlBarshaSEO } from "../helmets/WebDevelopment/al_barsha";
import { CreativeWebsiteDesignCompanyInBurDubaiSEO } from "../helmets/WebDevelopment/bur_dubai";
import { TopWebsiteDesignCompanyInDIFCSEO } from "../helmets/WebDevelopment/difc";
import SeoPage from "./SearchEnginePage";

import React from "react";
import { useParams } from "react-router-dom";
import WebDevelopmentPage from "./WebdevelopmentPage";
import { BrandDevelopmentAgencyInDIFCSEO } from "../helmets/Branding/difc";
import { BrandingAgencyBurDubaiPage } from "../helmets/Branding/dubai";
import { BrandIdentityAgencyInAlBarshaSEO } from "../helmets/Branding/albarsha";
import BrandIdentityDevelopmentPage from "./BrandIdentityPage";
import { BestSocialMediaMarketingInDIFCSEO } from "../helmets/SocialMediaManagement/difc";
import { SocialMediaManagementCompanyInBurDubaiSEO } from "../helmets/SocialMediaManagement/bur_dubai";
import { SocialMediaBrandingAndStrategyInAlBarshaSEO } from "../helmets/SocialMediaManagement/al_barsha";
import SocialMediaBrandingPage from "./SocialMediaBrandingPage";
import { BestUIUXDesignServicesInDIFCSEO } from "../helmets/UIUXDesign/difc";
import { CreativeUIUXSolutionsInBurDubaiSEO } from "../helmets/UIUXDesign/bur_dubai";
import { UIUXWireframingServicesInAlBarshaSEO } from "../helmets/UIUXDesign/al_barsha";
import UIUXPage from "./UIUXPage";
import { BestEcommerceWebDesignAgencyInDIFCSEO } from "../helmets/Ecommerce/difc";
import {  CustomEcommerceSolutionsInBurDubaiSEO } from "../helmets/Ecommerce/bur_dubai";
import { EcommerceWebsiteDevelopmentInAlBarshaSEO } from "../helmets/Ecommerce/al_barsha";
import ECommercePage from "./EcommercePage";
import { VideoContentCreationForBrandsInDIFCSEO } from "../helmets/VideoAdProduction/difc";
import { SocialMediaVideoProductionInBurDubaiSEO } from "../helmets/VideoAdProduction/bur_dubai";
import { CreativeVideoProductionCompanyInAlBarshaSEO } from "../helmets/VideoAdProduction/al_barsha";
import VideoAdProductionPage from "./VideoAdProductionPage";
import { BestSocialMediaAdvertisingInDIFCSEO } from "../helmets/PaidAdvertising/difc";
import { PaidSocialMediaCampaignsInBurDubaiSEO } from "../helmets/PaidAdvertising/bur_dubai";
import { BestSocialMediaMarketingAgencyInAlBarshaSEO } from "../helmets/PaidAdvertising/al_barsha";
import PaidMediaCampaignsPage from "./PaidMediaCampaignPage";

const ServiceLocation = () => {
  const { service, location } = useParams();
  if (service === "digital-marketing" && location === "difc") {
    return (
      <>
        <DigitalMarketingAgencyNearDifcPage />
      </>
    );
  } else if (service === "digital-marketing" && location === "bur-dubai") {
    return (
      <>
        <BestDigitalMarketingAndSEOInBurDubaiSEO />
      </>
    );
  } else if (service === "digital-marketing" && location === "al-barsha") {
    return (
      <>
        <TopDigitalMarketingAgencyAlBarshaPage />
      </>
    );
  } else if (service === "digital-marketing" && location === "diera") {
    return (
      <>
        <BestDigitalMarketingAndSEOInBurDubaiSEO />
      </>
    );
  } else if (service === "digital-marketing" && location === "jumeirah") {
    return (
      <>
        <BestDigitalMarketingAndSEOInBurDubaiSEO />
      </>
    );
  } else if (service === "digital-marketing" && location === "dubai-marina") {
    return (
      <>
        <BestDigitalMarketingAndSEOInBurDubaiSEO />
      </>
    );
  } else if (service === "digital-marketing" && location === "dubai") {
    return (
      <>
        <BestDigitalMarketingAndSEOInDubaiSEO />
      </>
    );
  } else if (service === "seo" && location === "difc") {
    return (
      <>
        <BestSEOCompanyInDIFCSEO />
      </>
    );
  } else if (service === "seo" && location === "bur-dubai") {
    return (
      <>
        <BestSEOCompanyInBurDubaiSEO />
      </>
    );
  } else if (service === "seo" && location === "al-barsha") {
    return (
      <>
        <BestSEOCompanyInAlBarshaSEO />
      </>
    );
  } else if (service === "seo" && location === "diera") {
    return (
      <>
        <BestDigitalMarketingAndSEOInBurDubaiSEO />
      </>
    );
  } else if (service === "seo" && location === "jumeirah") {
    return (
      <>
        <BestDigitalMarketingAndSEOInBurDubaiSEO />
      </>
    );
  } else if (service === "seo" && location === "dubai-marina") {
    return (
      <>
        <BestDigitalMarketingAndSEOInBurDubaiSEO />
      </>
    );
  } else if (service === "seo" && location === "dubai") {
    return (
      <>
        <SeoPage />
      </>
    );
  } else if (service === "web-development" && location === "difc") {
    return <TopWebsiteDesignCompanyInDIFCSEO />;
  } else if (service === "web-development" && location === "dubai") {
    return <WebDevelopmentPage />;
  } else if (service === "web-development" && location === "bur-dubai") {
    return <CreativeWebsiteDesignCompanyInBurDubaiSEO />;
  } else if (service === "web-development" && location === "al-barsha") {
    return <CreativeWebsiteDesignCompanyInAlBarshaSEO />;
  } else if (service === "brand-identity-development" && location === "difc") {
    return <BrandDevelopmentAgencyInDIFCSEO />;
  } else if (
    service === "brand-identity-development" &&
    location === "bur-dubai"
  ) {
    return <BrandingAgencyBurDubaiPage />;
  } else if (
    service === "brand-identity-development" &&
    location === "al-barsha"
  ) {
    return <BrandIdentityAgencyInAlBarshaSEO />;
  } else if (service === "brand-identity-development" && location === "dubai") {
    return <BrandIdentityDevelopmentPage />;
  }


  else if (service === "social-media-management" && location === "difc") {
    return <BestSocialMediaMarketingInDIFCSEO />;
  } else if (service === "social-media-management" && location === "bur-dubai") {
    return <SocialMediaManagementCompanyInBurDubaiSEO />;
  } else if (service === "social-media-management" && location === "al-barsha") {
    return <SocialMediaBrandingAndStrategyInAlBarshaSEO />;
  }
  else if (service === "social-media-management" && location === "dubai") {
    return <SocialMediaBrandingPage />;
  }


  else if (service === "ui-ux-design" && location === "difc") {
    return <BestUIUXDesignServicesInDIFCSEO />;
  } else if (service === "ui-ux-design" && location === "bur-dubai") {
    return <CreativeUIUXSolutionsInBurDubaiSEO />;
  } else if (service === "ui-ux-design" && location === "al-barsha") {
    return <UIUXWireframingServicesInAlBarshaSEO />;
  }
  else if (service === "ui-ux-design" && location === "dubai") {
    return <UIUXPage />;
  }


  else if (service === "e-commerce-solutions" && location === "difc") {
    return <BestEcommerceWebDesignAgencyInDIFCSEO />;
  } else if (service === "e-commerce-solutions" && location === "bur-dubai") {
    return <CustomEcommerceSolutionsInBurDubaiSEO />;
  } else if (service === "e-commerce-solutions" && location === "al-barsha") {
    return <EcommerceWebsiteDevelopmentInAlBarshaSEO />;
  }
  else if (service === "e-commerce-solutions" && location === "dubai") {
    return <ECommercePage />;
  }


  else if (service === "video-advertising-production" && location === "difc") {
    return <VideoContentCreationForBrandsInDIFCSEO />;
  } else if (service === "video-advertising-production" && location === "bur-dubai") {
    return <SocialMediaVideoProductionInBurDubaiSEO />;
  } else if (service === "video-advertising-production" && location === "al-barsha") {
    return <CreativeVideoProductionCompanyInAlBarshaSEO />;
  }
  else if (service === "video-advertising-production" && location === "dubai") {
    return <VideoAdProductionPage />;
  }



  
  else if (service === "paid-media-campaigns" && location === "difc") {
    return <BestSocialMediaAdvertisingInDIFCSEO />;
  } else if (service === "paid-media-campaigns" && location === "bur-dubai") {
    return <PaidSocialMediaCampaignsInBurDubaiSEO />;
  } else if (service === "paid-media-campaigns" && location === "al-barsha") {
    return <BestSocialMediaMarketingAgencyInAlBarshaSEO />;
  }
  else if (service === "paid-media-campaigns" && location === "dubai") {
    return <PaidMediaCampaignsPage />;
  }

  return (
    <>
      <div
        style={{
          padding: "50px",
          textAlign: "center",
        }}
      >
        <p>
          Welcome to MilaajBrandset 's services in . Our team is dedicated to
          delivering high - quality solutions to help your business thrive.{" "}
        </p>{" "}
      </div>{" "}
    </>
  );
};

export default ServiceLocation;
